import getSymbolFromCurrency from 'currency-symbol-map';

const getCurrencySymbol=(symbol:any)=>
{
  return getSymbolFromCurrency(symbol);
}
export default getCurrencySymbol;